import { defineMessages, useIntl } from 'react-intl';

import { TwcSpotlightCard } from './TwcSpotlightCard';

import { buttonMessages } from './button-messages';

import { HOME_SPOTLIGHT_NUMBER } from './constants';

import HomeIllustrationDark from '../../assets/Home-Illustration-Dark.png';

import HomeIllustrationLight from '../../assets/Home-Illustration-Light.png';

import { type JSX } from 'react/jsx-runtime';

type HomeSpotlightProps = {
	userName?: string;
	numTotalSpotlights: number;
	spotlightEnd: () => void;
	spotlightNext: () => void;
};

export const HomeSpotlight = (props: HomeSpotlightProps): JSX.Element => {
	const { userName, numTotalSpotlights, spotlightEnd, spotlightNext } = props;
	const intl = useIntl();

	return (
		<TwcSpotlightCard
			testId="for-you-spotlight"
			heading={
				userName
					? intl.formatMessage(messages.headingWithName, { name: userName })
					: intl.formatMessage(messages.genericHeading)
			}
			body={intl.formatMessage(messages.body)}
			lightSrcImage={HomeIllustrationLight}
			darkSrcImage={HomeIllustrationDark}
			primaryInteraction="next"
			primaryActionFunction={spotlightNext}
			primaryActionText={intl.formatMessage(buttonMessages.spotlightNextButton)}
			spotlightEnd={spotlightEnd}
			currentSpotlightNumber={HOME_SPOTLIGHT_NUMBER}
			numTotalSpotlights={numTotalSpotlights}
			spotlightType="for_you"
		/>
	);
};

const messages = defineMessages({
	headingWithName: {
		defaultMessage: 'Welcome Home, {name}!',
		description:
			'Heading for team work collection onboarding tour spotlight for the "for you" page',
		id: 'townsquare.twc-onboarding-modal.for-you.heading',
	},
	genericHeading: {
		defaultMessage: 'Welcome Home!',
		description:
			'Heading for team work collection onboarding tour spotlight for the "for you" page',
		id: 'townsquare.twc-onboarding-modal.for-you.generic-heading',
	},
	body: {
		defaultMessage:
			"Home connects work from across Atlassian, giving you an overview of what's happening across teams, goals, and projects.",
		description: "Body for team work collection onboarding tour spotlight for the 'for you' page",
		id: 'townsquare.twc-onboarding-modal.for-you.body',
	},
});
